import upload from "./upload.svg";

export default function UploadIcon() {
  return (
    <img src={upload} />
  );
}